import { IAccommodationRoom } from "Bands/types";
import { orderBy } from "lodash-es";
import { copy } from "shared/assets";
import { ISelectOption } from "shared/components/Form/Fields/select/types";
import { IFieldType, IFormFields } from "shared/types";

const { accommodationBlock: blockCopy } = copy;

interface Props {
  availableRoomTypes: ISelectOption[];
  availableRooms: IAccommodationRoom[];

  setNbPeople: (nbPeople: number) => void;

  selectedRoomType: string;
  setSelectedRoomType: (selectedRoomType: string) => void;

  selectedRoomTypeLabel: string;

  isEdit: boolean;
  currentRoom?: string;
}

export const getFields = ({
  availableRoomTypes,
  availableRooms,

  setNbPeople,
  setSelectedRoomType,

  selectedRoomTypeLabel,

  isEdit,
  currentRoom,
}: Props): IFormFields => {
  const fields: IFormFields = [
    isEdit
      ? {
          name: "people",
          label: blockCopy.create.peopleBlock.fields.name,
          type: IFieldType.singlePeoplePicker,
          validation: {
            required: blockCopy.create.roomsBlock.errors.required,
          },
          style: {
            gridColumn: "span 2",
            maxWidth: "100%",
          },
          disabled: isEdit,
          onChange: selected => setNbPeople(selected === undefined ? 0 : selected.length),
          ...(isEdit && {
            fieldLink: {
              label: "",
              onClick: () => {},
            },
          }),
          settings: {
            includeInvitedUsers: true,
          },
        }
      : {
          name: "people",
          label: blockCopy.create.peopleBlock.fields.name,
          type: IFieldType.peoplePicker,
          validation: {
            required: blockCopy.create.roomsBlock.errors.required,
          },
          style: {
            gridColumn: "span 2",
            maxWidth: "100%",
          },
          disabled: isEdit,
          onChange: selected => setNbPeople(selected === undefined ? 0 : selected.length),
          settings: {
            includeInvitedUsers: true,
            filterOnStatus: true,
          },
        },
    {
      name: "roomType",
      label: blockCopy.create.peopleBlock.fields.roomType,
      type: IFieldType.select,
      options: availableRoomTypes,
      style: {
        gridColumn: "span 2",
        maxWidth: "100%",
      },
      disabled: !availableRoomTypes.length,
      placeholder: blockCopy.create.peopleBlock.placeholders.roomType,
      onChange: type => {
        setSelectedRoomType((type && type.value) || "");
      },
    },
    {
      name: "room",
      label: blockCopy.create.peopleBlock.fields.assignRoom,
      type: IFieldType.select,
      style: {
        gridColumn: "span 2",
        maxWidth: "100%",
      },
      placeholder: blockCopy.create.peopleBlock.placeholders.assignRoom,
      disabled: availableRooms.length === 0,
      options: orderBy(availableRooms, room => parseInt(room.roomNumber)).map(
        room =>
          ({
            label: `${selectedRoomTypeLabel} #${room.roomNumber} ${
              currentRoom && currentRoom === room.id ? "(current room)" : ""
            }`,
            value: room.id,
          } as ISelectOption)
      ),
    },
  ];

  if (isEdit) {
    fields.push({
      name: "remark",
      label: blockCopy.create.peopleBlock.fields.remark,
      type: IFieldType.textarea,
      style: {
        gridColumn: "span 6",
      },
      placeholder: blockCopy.create.peopleBlock.placeholders.remark,
    });
  }

  return fields;
};
